import { render, staticRenderFns } from "./ThemeSettings.vue?vue&type=template&id=6ee9cb63&"
import script from "./ThemeSettings.vue?vue&type=script&lang=ts&"
export * from "./ThemeSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports